import React from "react";
import TagsFilterCombobox from "components/directus/combobox/tags-filter";

// `tags.for` value for tags applied to jobs
export const JOB_TAG_FOR = "jobs";

/**
 * Single job-tag picker for revenue dashboards. The selected id is sent to the
 * revenue-calculation endpoints as `jobTagId`.
 */
export function JobTagsFilterCombobox({ value, onChange, className = "w-40" }) {
  return (
    <TagsFilterCombobox
      isMulti
      for={JOB_TAG_FOR}
      value={value}
      onChange={(id) => onChange(id || undefined)}
      hideLabel
      className={className}
    />
  );
}
